import { MotifButton } from '@ey-xd/motif-react';
import WorkspaceStatus from '../atoms/WorkspaceStatus';
import React from 'react';
import ApprovalQuestionOption from './ApprovalQuestionOption';
import { datePipeForTable } from '../../helpers/util';

const ApprovalQuestionDetails = (props: any) => {
  const { details, onCancel, approveBtnClicked, rejectBtnClicked } = props;
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <span className="bg-[#4E4E5D] px-2 py-1 rounded-md text-sm">Question</span>
          <div className="flex gap-2 items-center !text-[#9897A6]">
            <span>Status:</span>
            {/* <WorkspaceStatus status={'Active'} /> */}
            <WorkspaceStatus status={details?.Status} />
          </div>
        </div>
        <div className="text-sm">
          { details?.Question }
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <span className="bg-[#4E4E5D] px-2 py-1 rounded-md text-sm">Options</span>
        </div>
        <div className="flex gap-3">
            <div className="w-[calc(100%/3)]">
            <ApprovalQuestionOption content={details?.Options[0].option} optionNumber={1} selected={details?.Options[0].selected} />
            </div>
            <div className="w-[calc(100%/3)]">
            <ApprovalQuestionOption content={details?.Options[1].option} optionNumber={2} selected={details?.Options[1].selected} />
            </div>
            <div className="w-[calc(100%/3)]">
            <ApprovalQuestionOption content={details?.Options[2].option} optionNumber={3} selected={details?.Options[2].selected} />
            </div>
        </div>
      </div>
      <hr className="border-[#2E2E38]" />
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <span className="bg-[#4E4E5D] px-2 py-1 rounded-md text-sm">Customized query</span>
          <div className="flex gap-2 items-center !text-[#9897A6]">
            <div className="flex gap-2 items-center">
              <span>Added by:</span>
              <span>{ details?.CreatedBy }</span>
            </div>
            <span>|</span>
            <div className="flex gap-2 items-center">
              <span>Added on:</span>
              <span>{ details?.CreatedDate ? datePipeForTable(details?.CreatedDate) : "" }</span>
            </div>
          </div>
        </div>
        <div className="bg-[#23232F] border border-[#4E4E5D] p-3 rounded-md text-sm min-h-40">
        { details?.CustomizedQuery }
        </div>
      </div>
      <div className="border-t border-[#2E2E38] p-3 flex justify-end gap-3">
        <MotifButton
          onClick={onCancel}
          type="button"
          variant="secondary"
          size="small"
          className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
        >
          Cancel
        </MotifButton>
        <MotifButton
          type="submit"
          variant="secondary"
          size="small"
          onClick={() => {rejectBtnClicked(details)}}
          className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
          disabled= { details?.Status == "Approved" || details?.Status == "Rejected" }
        >
          Reject
        </MotifButton>
        <MotifButton
          type="submit"
          variant="primary"
          size="small"
          onClick={() => {approveBtnClicked(details)}}
          className="flex items-center justify-center !h-12 !w-20 !min-w-0 !rounded-md"
          disabled= { details?.Status == "Approved" || details?.Status == "Rejected" }
        >
          Approve
        </MotifButton>
      </div>
    </div>
  );
};

export default ApprovalQuestionDetails;
